import { render } from "./Terceros.vue?vue&type=template&id=431222f4&scoped=true"
import script from "./Terceros.vue?vue&type=script&lang=js"
export * from "./Terceros.vue?vue&type=script&lang=js"

import "./Terceros.vue?vue&type=style&index=0&id=431222f4&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431222f4"]])

export default __exports__